import { DirectionsCacheEntry } from '../../services/directionsCacheService';
import {
  CACHE_DIRECTIONS_RESULT,
  CLEAN_EXPIRED_CACHE_ENTRIES,
  CLEAR_DIRECTIONS_CACHE,
  INVALIDATE_DIRECTIONS_CACHE_FOR_TICKET,
} from '../../constants/actionConstants';

/**
 * Payload for caching a directions result
 */
export interface CacheDirectionsPayload {
  cacheKey: string;
  entry: DirectionsCacheEntry;
}

/**
 * Action to cache a directions API result
 */
export function cacheDirectionsResult(
  cacheKey: string,
  result: google.maps.DirectionsResult,
  ticketId: string,
  origin: { lat: number; lng: number },
  destination: { lat: number; lng: number },
) {
  return {
    type: CACHE_DIRECTIONS_RESULT,
    payload: {
      cacheKey,
      entry: {
        result,
        timestamp: Date.now(),
        ticketId,
        origin,
        destination,
      },
    },
  };
}

/**
 * Action to clean expired cache entries
 */
export function cleanExpiredCacheEntries() {
  return {
    type: CLEAN_EXPIRED_CACHE_ENTRIES,
  };
}

/**
 * Action to clear the entire directions cache
 */
export function clearDirectionsCache() {
  return {
    type: CLEAR_DIRECTIONS_CACHE,
  };
}

/**
 * Action to invalidate cache for a specific ticket
 * Called when ticket is closed, updated, or geozone changes
 */
export function invalidateDirectionsCacheForTicket(ticketId: string) {
  return {
    type: INVALIDATE_DIRECTIONS_CACHE_FOR_TICKET,
    payload: { ticketId },
  };
}
